import { render, staticRenderFns } from "./tabs-price.vue?vue&type=template&id=504bf1b2&scoped=true"
import script from "./tabs-price.vue?vue&type=script&lang=js"
export * from "./tabs-price.vue?vue&type=script&lang=js"
import style0 from "./tabs-price.vue?vue&type=style&index=0&id=504bf1b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504bf1b2",
  null
  
)

export default component.exports